import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import Handlebars from 'handlebars';
import GenericView from '../../prototypes/generic.view.ts';
import Template from 'text-loader!../templates/resetPassword.template.hbs';
// import 'dhtmlxMessage';
import i18n  from "l10n";

export default GenericView.extend({
    el: "#main",
    tagName: 'div',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();

        this.userHash = options ? options.userHash : null;

        this.fields = {
            newPassword: [this.isEmpty, this.minLengthNumber, this.maxLengthNumber, this.isNoValidPassword],
            confirmPassword: [this.isEmpty, this.sameValues]
        };
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template());
	},
    events:{
		"click #resetButton": "reset",
		"change .to-validation": "validateIt",
        "keyup .to-validation": "validateIt",
	},
	validateIt: function(event)
    {
        var element = $(event.currentTarget);
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        //console.info(field);
        this.validateFields( field );
    },
	reset: function() {
        var self = this;

        var has_error = this.validateFields(this.fields);
        //console.info("has error: " + has_error);

        var newPassword = encodeURIComponent($("#newPassword").val());
        var confirmPassword = encodeURIComponent($("#confirmPassword").val());

        //todo: check if passwords are the same

        if(has_error) {
            $.notify(i18n.t("store.invalidInputs"), {className: "error"});
            return;
        }
        $.ajaxDefaultQ({
            url: window.ip+'/rest/auth/users/forgotPassword/' + this.userHash + '?newPassword=' + newPassword,
            type: 'POST',
            data: "token=" + this.userHash + "&password=" + confirmPassword,
            beforeSend: function (xhr) {
                //xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
            }
        }).done(function(response, status, xhr){
            if(status == "success")
            {
                $.notify(i18n.t("account.password_success_change"), { position:"top center", className: "success"});
                setTimeout(() => {
                    window.open('/login.html','_self');
                }, 5000);
            }
        })
        .fail(function(response) {
            var errorCode = response.responseJSON.error.code
            if (errorCode === 121) {
                $.notify(i18n.t("account.oldPassword_sameWithNew"), {position:"top center", className: "error"});
            } else if  (errorCode === 122) {
                $.notify(i18n.t("account.expired_reset_token"), {position:"top center", className: "error"});
            } else if  (errorCode === 123) {
                $.notify(i18n.t("account.invalid_reset_token"), {position:"top center", className: "error"});
            }
        });

        return false;
	}
});

